import styled from "styled-components";

export interface RichTextBannerBoxProps {
	color: string;
}

export const RichTextBannerBox = styled("div").withConfig({
	shouldForwardProp: (prop) => !["color"].includes(prop),
})<RichTextBannerBoxProps>`
	width: 100%;
	margin: 0 auto;
	padding: 12px;
	box-sizing: border-box;
	color: #333;
	background-color: ${(props: RichTextBannerBoxProps) => props.color};
	& > div {
		overflow: hidden;
		padding: 0;
		margin: 0;
	}
`;

RichTextBannerBox.defaultProps = {
	color: "#fff",
};
